export function dateWithoutTime ( date ) {
    
    var date2 = date;
    if ( Object.prototype.toString.call( date ) !== '[object Date]' )
        date2 = new Date( date );
    
    var y = date2.getFullYear();
    var m = date2.getMonth();
    var d = date2.getDate();

    //Convert to correct format, i.e month: 1 => 02
    m = m + 1;
    m = m < 10 ? "0" + m : m;

    //Convert to correct format, i.e date: 1 => 01
    d = d < 10 ? "0" + d : d;

    return y + "-" + m + "-" + d;
}